/**
 * @author  Uladzimir Ambrazhey, <v.ambrazhey@lovata.com>, LOVATA Group
 * @author  Andrey Kharanenka, a.khoronenko@lovata.com, LOVATA Group
 */
export default class ShopaholicCartClear {
	constructor() {
		this.sDefaultButtonClass    = '_shopaholic-cart-clear';
		this.sRemoveComponentMethod = 'Cart::onClear';
		this.obAjaxRequestCallback  = null;
	}
	
	/**
	 * Init event handlers
	 */
	init() {
		const self = this;
		document.addEventListener('click', function (obEvent) {
			if (!obEvent.target.matches(`.${self.sDefaultButtonClass}`)) return;
			obEvent.preventDefault();
			
			const {target:obButton} = obEvent;
			if (obButton.hasAttribute('disabled')) {
				return;
			}
			
			self.sendAjaxRequest(obButton);
		});
	}
	
	/**
	 * Remove cart position
	 * @param {EventTarget|Element} obButton
	 */
	sendAjaxRequest(obButton) {
		if (!obButton) {
			throw new Error('Button node is empty.');
		}
		
		obButton.setAttribute('disabled', 'disabled');
		
		let obRequestData = {
			complete:({data}) => {
				this.completeCallback(data, obButton);
			}
		};
		
		if (this.obAjaxRequestCallback !== null) {
			obRequestData = this.obAjaxRequestCallback(obRequestData, obButton);
		}
		
		oc.ajax(this.sRemoveComponentMethod, obRequestData);
	}
	
	/**
	 * Remove disabled attribute from button
	 * Update cart data in ShopaholicCart object
	 */
	completeCallback(obResponse, obButton) {
		if (obButton) {
			obButton.removeAttribute('disabled');
		}
	}
	
	/**
	 * Set ajax request callback
	 *
	 * @param {function} obCallback
	 * @returns {ShopaholicCartRemove}
	 */
	setAjaxRequestCallback(obCallback) {
		this.obAjaxRequestCallback = obCallback;
		
		return this;
	}
}
